import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Container, Paper, Typography } from '@mui/material';

const MaidRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6">Loading...</Typography>
        </Paper>
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isMaid = user.role && (
    typeof user.role === 'object'
      ? user.role.name === 'MAID'
      : user.role === 'MAID'
  );

  if (!isMaid) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default MaidRoute;
